"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
var React = __importStar(require("react"));
var bind_1 = __importDefault(require("classnames/bind"));
var styles = __importStar(require("./styles.modules.css"));
var lib_1 = require("@ribit/lib");
var form_1 = require("../form");
var text_1 = require("../text");
var cx = bind_1.default.bind(styles);
var defaultProps = {
    layout: "vertical",
    label: undefined,
};
var Field = /** @class */ (function (_super) {
    __extends(Field, _super);
    function Field() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (name, value, multiple, isInitial) {
            _this.context.form.valueChanged(name, value, multiple, isInitial);
        };
        return _this;
    }
    Field.prototype.componentDidMount = function () {
        if (this.context && this.context.form) {
            this.context.form.registerField(this);
        }
    };
    Object.defineProperty(Field.prototype, "control", {
        get: function () {
            var _a = this.props, control = _a.control, children = _a.children;
            return control ? control : children;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "label", {
        get: function () {
            var label = this.props.label;
            if (label) {
                return label;
            }
            var name = this.control.props.name;
            if (!name) {
                (0, lib_1.warn)("You must specify either a label on the field, or a name on the control within it.");
            }
            return (0, lib_1.toTitleCase)(name);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "name", {
        get: function () {
            return this.control.props.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "errors", {
        get: function () {
            var errors = this.context.errors;
            if (!errors) {
                return [];
            }
            return errors[this.name];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "hasErrors", {
        get: function () {
            return !!(this.errors || (this.errors && this.errors.length));
        },
        enumerable: false,
        configurable: true
    });
    Field.prototype.renderControl = function () {
        var _this = this;
        return (React.createElement(form_1.FormContext.Consumer, null, function (context) {
            return React.cloneElement(_this.control, __assign({ value: context.values[_this.name], onChange: _this.onChange, error: _this.hasErrors }, _this.control.props));
        }));
    };
    Field.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var _c = this.props, required = _c.required, layout = _c.layout, label = _c.label, labelClassName = _c.labelClassName, className = _c.className;
        var help = this.props.help;
        if (help) {
            help = React.createElement("div", { className: styles.help }, help);
        }
        var errorElements;
        if (this.hasErrors) {
            errorElements = this.errors.map(function (error, index) {
                return (React.createElement(text_1.Text, { className: styles.errorText, key: index, dangerous: true }, error));
            });
        }
        var className_ = cx((_a = {
                outer: true,
                error: this.hasErrors
            },
            _a[layout] = true,
            _a[className] = className,
            _a));
        var labelClassName_ = cx((_b = {
                labelContainer: true
            },
            _b[labelClassName] = labelClassName,
            _b));
        return (React.createElement("div", { className: className_, ref: function (element) { return (_this.element = element); } },
            label !== null || help ? (React.createElement("div", { className: labelClassName_ },
                label !== null ? (React.createElement("label", { className: styles.label },
                    this.label,
                    " ",
                    required ? "*" : "")) : null,
                help)) : null,
            this.renderControl(),
            errorElements));
    };
    Field.defaultProps = defaultProps;
    Field.contextType = form_1.FormContext;
    return Field;
}(React.Component));
exports.Field = Field;
exports.default = Field;
//# sourceMappingURL=field.js.map